import React, { useEffect, useState } from 'react';
import { fetchElevation } from '../services/elevationService';

/**
 * 国盗り地図の位置情報コンポーネント
 */
const KntrLocationInfo = ({
  locationInfo,
  onLocationUpdate,
}) => {

  const address = locationInfo?.address || '';
  const center = locationInfo?.center || null;

  // 標高情報の状態管理
  const [elevation, setElevation] = useState(null);

  // 座標が変わったら標高情報を取得
  useEffect(() => {
    if (center?.lat && center?.lng) {
      fetchElevation(center.lat, center.lng)
        .then(data => {
          setElevation(data);
          // 親コンポーネントに通知
          if (onLocationUpdate) {
            onLocationUpdate({ elevation: data });
          }
        })
        .catch(() => {
          setElevation(null);
        });
    }
  }, [center, onLocationUpdate]);

  // 国盗り地図用レイアウトとして、表示用に「住所（標高xx）」を組み立て
  // 数値なら単位付き、そうでなければそのまま（不明ラベル）
  const elevationText =
    typeof elevation === 'number'
      ? `${elevation}m`
      : elevation;
  // 「住所がある」かつ「標高表示がある」時だけ標高付け足し
  let addressLine = address;
  if (address && elevationText) {
    addressLine = `${address}（標高:${elevationText}）`;
  }

  return (
    <>
      {/* Kntrでは住所と標高をアイコンなしで出す */}
      <div className="kntr-address-info">
        {addressLine}
      </div>
    </>
  );
};

export default KntrLocationInfo;